export type EditKeysType = 'COMPLETED_UNTIL' | 'PRODUCT_COMPLETION_FINAL_PRODUCTS';

export const EDIT_KEYS = ['COMPLETED_UNTIL', 'PRODUCT_COMPLETION_FINAL_PRODUCTS'];

export const STORAGE_KEY = 'productCompletionSheetEditData';
